import logo from 'url:../../images/logo.png';

function Logo(props) {
    return (
        <img src={logo} width={props.logoWidth} />
    );
}

export default Logo;